// Retailer configuration
export const RETAILER_LOGOS = {
  "Amazon": "/images/retailers/AmazonLogo.png",
  "Scheels": "/images/retailers/ScheelsLogo.png",
  "Bass Pro": "/images/retailers/bass-pro-logo.svg",
  "Cabela's": "/images/retailers/CabelasLogo.png",
  "FishUSA": "/images/retailers/FishUSALogo.png",
  "Sportsman's Warehouse": "/images/retailers/SportsmansWarehouseLogo.png",
  "Sportsman's Guide": "/images/retailers/SportsmansGuideLogo.png"
}; 